import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import DropHeatsheet from '../components/DropHeatsheet';
import HeatsheetList from '../components/HeatsheetList';

export default function Admin({ team, user }) {
    return (
        <Container>
            <Row style={{ minHeight: '4vh' }} />
            <Row>
                <Col>
                    <h3>Heat sheets</h3>
                    <HeatsheetList team={team} user={user} />
                </Col>
            </Row>
            <Row style={{ minHeight: '2vh' }} />
            <Row>
                <Col className="Uploadcol">
                    <DropHeatsheet team={team} user={user} />
                </Col>
            </Row>
        </Container>
    );
}
